export default "__VITE_ASSET__51f0bee3__"